export interface SERVICE_CARD {
  title: string;
  icon_src: string;
  description: JSX.Element;
}

export interface SERVICE_ITEM {
  title: string;
  description: JSX.Element;
  img_src: string;
  href: string;
  cards: SERVICE_CARD[];
  btnText: string;
}

export interface CATEGORY_SERVICES {
  category_title: string;
  services: SERVICE_ITEM[];
}

const PARA_SUA_EMPRESA: CATEGORY_SERVICES = {
  category_title: 'PARA SUA EMPRESA',
  services: [
    {
      title: 'CAIXA Alimentação',
      href: '/alimentacao',
      description: (
        <>
          <p>
            Com o cartão <b>CAIXA Alimentação</b>, seus funcionários têm
            liberdade para escolher onde comprar alimentos de qualidade e itens
            para abastecer a despensa.
          </p>
          <p>
            Usando a <b>tecnologia VR</b>, os usuários contam com App dedicado e
            rede credenciada completa, com mercados, açougues e até Apps de
            delivery.
          </p>
        </>
      ),
      img_src: '/assets/services/PARA_SUA_EMPRESA-alimentacao.png',
      cards: [
        {
          icon_src: '/icons/shop.png',
          title: 'Ampla rede',
          description: (
            <>
              Rede credenciada VR, com mais de 589 mil estabelecimentos no
              Brasil.
            </>
          ),
        },
        {
          icon_src: '/icons/group.png',
          title: 'App completo',
          description: (
            <>Gestão total do saldo e localizador de estabelecimentos.</>
          ),
        },
        {
          icon_src: '/icons/credit-card.png',
          title: 'Autonomia',
          description: (
            <>
              A empresa define as condições de crédito e gerencia os benefícios
              no portal exclusivo.
            </>
          ),
        },
        {
          icon_src: '/icons/administration.png',
          title: 'Segurança jurídica',
          description: (
            <>
              Solução <b>100% aderente à legislação</b>, disponível nas
              modalidades PAT e Auxílio.
            </>
          ),
        },
      ],
      btnText: 'CONHEÇA EM DETALHES',
    },
    {
      title: 'CAIXA Refeição',
      href: '/refeicao',
      description: (
        <>
          <p>
            Alimentação completa para o trabalhador é com o{' '}
            <b>CAIXA Refeição!</b> Um cartão completo, que permite mais
            comodidade, praticidade e economia para que seus funcionários
            escolham aonde ir na hora das refeições.
          </p>
          <p>
            Seja em restaurantes ou aplicativos de delivery, quem tem CAIXA
            Refeição tem à mão a <b>tecnologia VR </b> e um App dedicado, além
            de uma sólida rede credenciada.
          </p>
        </>
      ),
      img_src: '/assets/services/PARA_SUA_EMPRESA-refeicao.png',
      cards: [
        {
          icon_src: '/icons/shop.png',
          title: 'Rede credenciada VR',
          description: <>Mais de 589 mil estabelecimentos no Brasil.</>,
        },
        {
          icon_src: '/icons/credit-card.png',
          title: 'App completo',
          description: (
            <>
              Tudo em um só lugar: saldo, histórico de uso e busca de locais
              credenciados.
            </>
          ),
        },
        {
          icon_src: '/icons/group.png',
          title: 'Controle total',
          description: (
            <>
              Portal exclusivo para a gestão do benefício: datas, valores,
              condições e muito mais!
            </>
          ),
        },
        {
          icon_src: '/icons/administration.png',
          title: 'Segurança jurídica',
          description: (
            <>
              Solução <b>100% aderente à legislação</b>, disponível nas
              modalidades PAT e Auxílio.
            </>
          ),
        },
      ],
      btnText: 'CONHEÇA EM DETALHES',
    },
    {
      title: 'CAIXA Multi',
      href: '/multi',
      description: (
        <>
          Concentra os saldos de Alimentação e Refeição em um só Cartão!
          Múltiplas vantagens para quem tem e para quem oferece, pois garante
          flexibilidade para os colaboradores e segurança jurídica para a
          empresa. Conta com as mesmas características dos cartões CAIXA
          Alimentação e Refeição: o App dedicado, a{' '}
          <b>tecnologia e a rede credenciada VR</b>.
        </>
      ),
      img_src: '/assets/services/PARA_SUA_EMPRESA-multi.png',
      cards: [
        {
          icon_src: '/icons/credit-card.png',
          title: 'Dois benefícios, um cartão',
          description: (
            <div className="flex flex-col gap-1">
              <p>
                Refeição e alimentação com saldos independentes ou unificados*.
              </p>
              <p className="text-xs">
                *Disponibilidade conforme modalidade contratada
              </p>
            </div>
          ),
        },
        {
          icon_src: '/icons/shop.png',
          title: 'Atendimento 100% online',
          description: (
            <>
              Suporte a gestores do benefício pelo WhatsApp e Portal do Cliente.
            </>
          ),
        },
        {
          icon_src: '/icons/group.png',
          title: 'Autonomia',
          description: (
            <>
              A empresa define as condições de crédito e gerencia os benefícios
              no portal exclusivo.
            </>
          ),
        },
        {
          icon_src: '/icons/administration.png',
          title: 'Segurança jurídica',
          description: (
            <>
              Solução <b>100% aderente à legislação</b>, disponível nas
              modalidades PAT e Auxílio.
            </>
          ),
        },
      ],
      btnText: 'CONHEÇA EM DETALHES',
    },
    {
      title: 'tagCAIXA Empresas',
      href: '/tagcaixa',
      description: (
        <>
          <p>
            Pague pedágios e estacionamentos sem fila e sem burocracia. A tag de
            pagamento veicular automático da CAIXA Pré-Pagos garante uma
            mobilidade mais eficiente à sua empresa, com controle e agilidade.
          </p>
          <p>
            A tecnologia de ponta da rede <b>Sem Parar Empresas®</b> completa o
            time campeão, que elimina o uso de dinheiro ou cartões, trazendo
            mais segurança e tranquilidade em cada viagem.
          </p>
        </>
      ),
      img_src: '/assets/services/PARA_SUA_EMPRESA-tagCAIXA.png',
      cards: [
        {
          icon_src: '/icons/shop.png',
          title: 'Aceita em todo o Brasil',
          description: (
            <>
              Em 100% dos pedágios automáticos e em mais de 2.700
              estacionamentos.
            </>
          ),
        },
        {
          icon_src: '/icons/group.png',
          title: 'Logística otimizada',
          description: (
            <>
              Consulta de rotas e valores de pedágios para cálculos mais
              precisos.
            </>
          ),
        },
        {
          icon_src: '/icons/administration.png',
          title: 'Segurança total',
          description: (
            <>Transações com tecnologia de ponta para proteção de dados.</>
          ),
        },
        {
          icon_src: '/icons/credit-card.png',
          title: 'Portal completo',
          description: (
            <>
              Gestão detalhada e individualizada das despesas com pedágios e
              estacionamentos.
            </>
          ),
        },
      ],
      btnText: 'CONHEÇA EM DETALHES',
    },
    {
      title: 'frotaCAIXA',
      href: '/frotacaixa',
      description: (
        <>
          <p>
            Gestão inteligente para seu negócio ir mais longe. Para empresas que
            precisam de controle completo e detalhado das frotas, o frotaCAIXA é
            o cartão que facilita a gestão do abastecimento de veículos e outros
            custos operacionais.
          </p>
          <p>
            A ampla rede de postos credenciados completa a oferta de uma solução
            confiável e robusta.
          </p>
        </>
      ),
      img_src: '/assets/services/PARA_SUA_EMPRESA-frotaCAIXA.png',
      cards: [
        {
          icon_src: '/icons/inventory.png',
          title: 'Planejamento de rota',
          description: (
            <>Roteiro e monitoramento das melhores rotas por veículo.</>
          ),
        },
        {
          icon_src: '/icons/group.png',
          title: 'Compare, não pare',
          description: (
            <>Diferentes postos de combustível para pesquisa do melhor preço.</>
          ),
        },
        {
          icon_src: '/icons/file-text.png',
          title: 'Portal completo',
          description: (
            <>
              Acesso a notas fiscais, definição de parâmetros de uso, permissões
              e muito mais.
            </>
          ),
        },
        {
          icon_src: '/icons/shop.png',
          title: 'Ampla rede',
          description: (
            <>
              <b>Mais de 11 mil postos</b> credenciados em todo o Brasil.
            </>
          ),
        },
      ],
      btnText: 'CONHEÇA EM DETALHES',
    },
    {
      title: 'vtCAIXA',
      href: '/vtcaixa',
      description: (
        <>
          <p>Inteligência e economia na gestão do vale-transporte.</p>
          <p>
            Com o vtCAIXA, sua empresa conta com processos facilitados e
            liberação rápida dos créditos no fornecimento do vale-transporte. A
            ferramenta Poupador ainda permite economia de até 20% nos pedidos,
            graças a uma tecnologia exclusiva. Tudo isso com um atendimento ágil
            e especializado, pensado para otimizar o trabalho do RH.
          </p>
        </>
      ),
      img_src: '/assets/services/PARA_SUA_EMPRESA-vtCAIXA.png',
      cards: [
        {
          icon_src: '/icons/shop.png',
          title: 'Rede completa',
          description: (
            <>Mais de 1.200 emissores credenciados em todo o Brasil.</>
          ),
        },
        {
          icon_src: '/icons/file-text.png',
          title: 'Economia',
          description: <>Até 20% menos gastos com o Poupador.</>,
        },
        {
          icon_src: '/icons/group.png',
          title: 'Ajuste automático',
          description: (
            <>
              Controle os gastos dos colaboradores e calcula automaticamente o
              saldo a depositar.
            </>
          ),
        },
        {
          icon_src: '/icons/credit-card.png',
          title: 'Plataforma simplificada',
          description: (
            <>Emissão, compra e controle do vale-transporte em um só Portal.</>
          ),
        },
      ],
      btnText: 'CONHEÇA EM DETALHES',
    },
    {
      title: 'despesaCAIXA',
      href: '/despesacaixa',
      description: (
        <>
          Com o <b className="font-semibold">despesaCAIXA</b>, sua empresa
          centraliza a gestão de despesas corporativas e benefícios em um único
          cartão, com controle total para o RH e flexibilidade para os
          colaboradores. A solução utiliza a bandeira{' '}
          <b className="font-semibold">Mastercard®</b> e uma plataforma digital
          completa para gestão de usuários, categorias, limites e relatórios,
          garantindo eficiência operacional, segurança jurídica e autonomia no
          dia a dia.
        </>
      ),
      img_src: '/assets/services/PARA_SUA_EMPRESA-despesaCAIXA.jpg',
      cards: [
        {
          icon_src: '/icons/acceptance.png',
          title: 'Ampla aceitação',
          description: (
            <>
              Aceito em mais de{' '}
              <b className="font-semibold">
                4 milhões de estabelecimentos credenciados Mastercard®
              </b>{' '}
              em todo o Brasil, para despesas corporativas e múltiplos
              benefícios.
            </>
          ),
        },
        {
          icon_src: '/icons/ok.png',
          title: 'Gestão centralizada',
          description: (
            <>
              Plataforma digital para controle total: definição de categorias de
              uso, limites por colaborador, transferência de saldos e relatórios
              em tempo real.
            </>
          ),
        },
        {
          icon_src: '/icons/collaborators.png',
          title: 'Autonomia para colaboradores',
          description: (
            <>
              Acesso pelo <b className="font-semibold">App</b> para consulta de
              saldo, gestão de carteiras, bloqueio e desbloqueio do cartão e
              compras online com segurança.
            </>
          ),
        },
        {
          icon_src: '/icons/shield-v.png',
          title: 'Segurança e conformidade',
          description: (
            <>
              Solução robusta, com controle de uso por categoria,
              rastreabilidade das transações e aderência às regras de benefícios
              corporativos.
            </>
          ),
        },
      ],
      btnText: 'CONHEÇA EM DETALHES',
    },
  ],
};

const PARA_VOCE: CATEGORY_SERVICES = {
  category_title: 'PARA VOCÊ',
  services: [
    {
      title: 'tagCAIXA',
      href: 'https://ecommerce.caixaprepagos.com.br/',
      description: (
        <>
          <p>Pague pedágios e estacionamentos sem fila e sem estresse.</p>
          <p>
            Com a tagCAIXA, você aproveita o caminho sem precisar colocar a mão
            no dinheiro nem na carteira. E ainda garante tranquilidade para
            passar pela nova geração dos pedágios, o <i>free flow</i>, sem o
            risco de tomar multas!
          </p>
          <p>
            <b>
              A tagCAIXA é aceita em toda a rede Sem Parar, em todo o Brasil:
            </b>
          </p>
        </>
      ),
      img_src: '/assets/services/PARA_VOCE-tagCAIXA.png',
      cards: [
        {
          icon_src: '/icons/administration.png',
          title: '100% dos pedágios',
          description: (
            <>
              Passe com tranquilidade em pedágios, com cancela ou no{' '}
              <i>free flow</i>.
            </>
          ),
        },
        {
          icon_src: '/icons/credit-card.png',
          title: '+ de 2.700 estacionamentos',
          description: (
            <>
              Estacione em shoppings, aeroportos e muito mais sem filas para
              pagar.
            </>
          ),
        },
        {
          icon_src: '/icons/debit-card.png',
          title: '+ de 2.800 postos de combustível          ',
          description: <>Abasteceu, pagou, saiu!</>,
        },
        {
          icon_src: '/icons/shop.png',
          title: 'Drive-thrus de grandes redes',
          description: (
            <>
              Bateu uma fome? Pague seu lanche em McDonald’s. Habib’s, Ragazzo,
              Jeronimo e mais.
            </>
          ),
        },
      ],
      btnText: 'ADQUIRA JÁ',
    },
    {
      title: 'CAIXA Alimentação',
      href: 'https://voce.caixaprepagos.com.br/',
      description: (
        <>
          <p>
            Com o cartão <b>CAIXA Alimentação</b>, você tem liberdade para
            escolher onde comprar alimentos de qualidade e itens para abastecer
            a despensa.
          </p>
          <p>
            Com <b>tecnologia VR</b>, você conta com App dedicado e rede
            credenciada completa, com mercados, açougues e até Apps de delivery.
          </p>
        </>
      ),
      img_src: '/assets/services/PARA_VOCE-alimentacao.png',
      cards: [
        {
          icon_src: '/icons/shop.png',
          title: 'Aceitação',
          description: (
            <>Ampla rede credenciada, com mais de 589 mil estabelecimentos.</>
          ),
        },
        {
          icon_src: '/icons/file-text.png',
          title: 'Inovação',
          description: (
            <>
              Aplicativo para consulta de saldo, extrato, promoções, pagamento
              por QRCode, cartão digital, entre outros .
            </>
          ),
        },
        {
          icon_src: '/icons/credit-card.png',
          title: 'Liberdade',
          description: (
            <>
              Escolha dos estabelecimentos nos quais usar o benefício, com
              cobertura nacional.
            </>
          ),
        },
        {
          icon_src: '/icons/administration.png',
          title: 'Tecnologia de Confiança',
          description: (
            <>
              Infraestrutura robusta e tecnologia de ponta da rede VR
              Benefícios.
            </>
          ),
        },
      ],
      btnText: 'PORTAL DO TRABALHADOR',
    },
    {
      title: 'CAIXA Refeição',
      href: 'https://voce.caixaprepagos.com.br/',
      description: (
        <>
          <p>
            Alimentação completa é com o <b>CAIXA Refeição</b>! Um cartão
            completo, que permite mais comodidade, praticidade e economia para
            que você escolha aonde ir na hora das refeições.
          </p>
          <p>
            Seja em restaurantes ou aplicativos de delivery, quem tem CAIXA
            Refeição tem à mão a <b>tecnologia VR</b> e um App dedicado, além de
            uma sólida rede credenciada.
          </p>
        </>
      ),
      img_src: '/assets/services/PARA_VOCE-refeicao.png',
      cards: [
        {
          icon_src: '/icons/shop.png',
          title: 'Aceitação',
          description: (
            <>Ampla rede credenciada, com mais de 589 mil estabelecimentos.</>
          ),
        },
        {
          icon_src: '/icons/file-text.png',
          title: 'Inovação',
          description: (
            <>
              Aplicativo para consulta de saldo, extrato, promoções, pagamento
              por QRCode, cartão digital, entre outros
            </>
          ),
        },
        {
          icon_src: '/icons/credit-card.png',
          title: 'Liberdade',
          description: (
            <>
              Escolha dos estabelecimentos nos quais usar o benefício, com
              cobertura nacional.
            </>
          ),
        },
        {
          icon_src: '/icons/administration.png',
          title: 'Tecnologia de Confiança',
          description: (
            <>
              Infraestrutura robusta e tecnologia de ponta da rede VR
              Benefícios.
            </>
          ),
        },
      ],
      btnText: 'PORTAL DO TRABALHADOR',
    },
    {
      title: 'CAIXA Multi',
      href: 'https://voce.caixaprepagos.com.br/',
      description: (
        <>
          <p>Concentra os saldos de Alimentação e Refeição em um só Cartão!</p>
          <p>
            Conta com as mesmas características dos cartões CAIXA Alimentação e
            Refeição, o App dedicado, a{' '}
            <b>tecnologia e a rede credenciada VR</b>, tudo em um só lugar.
          </p>
        </>
      ),
      img_src: '/assets/services/PARA_VOCE-multi.png',
      cards: [
        {
          icon_src: '/icons/credit-card.png',
          title: 'Dois benefícios, um cartão',
          description: (
            <div className="flex flex-col gap-1">
              <p>
                Refeição e alimentação com saldos independentes ou unificados*.
              </p>
              <p className="text-xs">
                *Disponibilidade conforme modalidade contratada
              </p>
            </div>
          ),
        },
        {
          icon_src: '/icons/shop.png',
          title: 'Aceitação nacional',
          description: (
            <>Ampla rede credenciada, com mais de 589 mil estabelecimentos.</>
          ),
        },
        {
          icon_src: '/icons/file-text.png',
          title: 'Inovação',
          description: (
            <>
              Aplicativo para consulta de saldo, extrato, promoções, pagamento
              por QRCode, cartão digital, entre outros
            </>
          ),
        },
        {
          icon_src: '/icons/administration.png',
          title: 'Tecnologia de Confiança',
          description: (
            <>
              Infraestrutura robusta e tecnologia de ponta da rede VR
              Benefícios.
            </>
          ),
        },
      ],
      btnText: 'PORTAL DO TRABALHADOR',
    },
  ],
};

export const SERVICES_ITEMS: {
  categories: CATEGORY_SERVICES[];
} = {
  categories: [PARA_VOCE, PARA_SUA_EMPRESA],
};
